import React, { Fragment } from "react";
import { Helmet } from "react-helmet";

import WorkComponent from "../../components/NewView/RootComponents/WorkComponent";

const VacanciesPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Робота в Харкові | Швидка робота та вакансії Yellow Hub</title>
        <meta
          name="description"
          content="Yellow Hub допоможе підібрати роботу в Харкові під твій досвід, графік і місто: швидка робота, вакансії партнерів, підробіток і цифрові задачі."
        />
        <meta
          name="keywords"
          content="робота Харків, вакансії Харків, швидка робота Харків, підробіток Харків, робота без досвіду Харків, цифрова робота, Yellow Hub робота, Єловхаб робота, Еллоу Хаб вакансії"
        />
        <link rel="canonical" href="https://yellowhub.com.ua/vacancies" />
        <meta property="og:title" content="Робота в Харкові - Yellow Hub" />
        <meta
          property="og:description"
          content="Підбір роботи під досвід, графік і місто: швидка робота, вакансії партнерів, підробіток і цифрові задачі."
        />
        <meta property="og:url" content="https://yellowhub.com.ua/vacancies" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Робота в Харкові - Yellow Hub",
            url: "https://yellowhub.com.ua/vacancies",
            description:
              "Сторінка з підбором роботи у Харкові під досвід, графік і місто: швидкі задачі, вакансії партнерів, підробіток і цифрова робота.",
            about: [
              "робота Харків",
              "вакансії Харків",
              "швидка робота",
              "підробіток",
              "цифрова робота",
            ],
            isPartOf: {
              "@type": "WebSite",
              name: "Yellow Hub",
              url: "https://yellowhub.com.ua",
            },
          })}
        </script>
      </Helmet>
      <WorkComponent />
    </Fragment>
  );
};

export default VacanciesPage;
